export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.52 5.75l-2.438 6.5H8.5c.716 0 1.188.568 1.28 1.124a2.25 2.25 0 004.44 0c.092-.556.564-1.124 1.28-1.124h3.418l-2.438-6.5H7.52zm11.73 8h-3.575a3.75 3.75 0 01-7.35 0H4.75v5.5h14.5v-5.5zM6.176 5.061a1.25 1.25 0 011.17-.811h9.308c.52 0 .987.323 1.17.811l2.926 7.803V19.5c0 .69-.56 1.25-1.25 1.25h-15c-.69 0-1.25-.56-1.25-1.25v-6.636l2.926-7.803z\" fill=\"#6F7488\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};